import { DURATION_TOLERANCE } from '../constants';

export function isDuplicateCycleUpdate(
	lastUpdate: { cycleId: string; start: number; end: number } | null,
	currentCycleId: string,
	currentStart: number,
	currentEnd: number,
	tolerance: number = DURATION_TOLERANCE
): boolean {
	if (!lastUpdate || lastUpdate.cycleId !== currentCycleId) {
		return false;
	}

	const isStartEqual = Math.abs(lastUpdate.start - currentStart) < tolerance;
	const isEndEqual = Math.abs(lastUpdate.end - currentEnd) < tolerance;
	const areBothValuesEqual = isStartEqual && isEndEqual;

	return areBothValuesEqual;
}
